export const UPDATE_SECOND_STAGE_FS_LEFT = `UPDATE_SECOND_STAGE_FS_LEFT`;
export const SHAKE_NORMAL_SCREEN = `SHAKE_NORMAL_SCREEN`;
export const HIDE_FS_ELEMENTS = `HIDE_FS_ELEMENTS`;
export const ANIMATE_BG_BILLBOARDS = `ANIMATE_BG_BILLBOARDS`;
export const RESTORE_BG_BILLBOARDS = `RESTORE_BG_BILLBOARDS`;
export const ADD_FAKE_SCATTER = `ADD_FAKE_SCATTER`;
export const UPDATE_FAKE_SCATTER_POSITION = `UPDATE_FAKE_SCATTER_POSITION`;
export const REMOVE_FAKE_SCATTERS = `REMOVE_FAKE_SCATTER`;
export const RESET_FAKE_SCATTERS = `RESET_FAKE_SCATTERS`;
export const SHOW_EASTER_EGG_ANIMATION = `SHOW_EASTER_EGG_ANIMATION`;
export const SHOW_FS_BILLBOARD = `SHOW_FS_BILLBOARD`;
export const SHOW_GREEN_BILLBOARD = `SHOW_GREEN_BILLBOARD`;
